import { render, staticRenderFns } from "./SubscriptionTermsAndCondition.vue?vue&type=template&id=220dc13a&scoped=true"
var script = {}
import style0 from "./SubscriptionTermsAndCondition.vue?vue&type=style&index=0&id=220dc13a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220dc13a",
  null
  
)

export default component.exports